import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { Link } from "react-router-dom";
import { COOKIE_CATEGORIES, readCookieConsent, saveCookieConsent } from "../lib/cookieConsent";

const ALL_ON = { necessari: true, statistiche: true, marketing: true };
const ONLY_NEEDED = { necessari: true, statistiche: false, marketing: false };

export function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [detailed, setDetailed] = useState(false);
  const [choices, setChoices] = useState(ONLY_NEEDED);

  useEffect(() => {
    const stored = readCookieConsent();
    if (!stored) setVisible(true);
    else setChoices({ ...ONLY_NEEDED, ...stored });
    const reopen = () => {
      setChoices({ ...ONLY_NEEDED, ...(readCookieConsent() || {}) });
      setDetailed(true);
      setVisible(true);
    };
    window.addEventListener("open-cookie-settings", reopen);
    return () => window.removeEventListener("open-cookie-settings", reopen);
  }, []);

  const decide = (value) => {
    saveCookieConsent(value);
    setVisible(false);
    setDetailed(false);
  };

  useEffect(() => {
    if (visible) document.body.dataset.cookieBanner = "open";
    else delete document.body.dataset.cookieBanner;
    return () => { delete document.body.dataset.cookieBanner; };
  }, [visible]);

  if (!visible) return null;

  return (
    <aside className="cookie-banner" data-testid="cookie-banner">
      <div className="cookie-head">
        <span className="cookie-mark"><Cookie size={17} /></span>
        <div>
          <p className="eyebrow">COOKIE E PRIVACY</p>
          <h2>Scegli cosa attivare</h2>
        </div>
      </div>
      <p className="cookie-copy">
        Usiamo cookie tecnici per tenere attivo l’accesso al tuo database. Statistiche e marketing restano spenti finché non li autorizzi.
        Dettagli nella <Link to="/legale/cookie" data-testid="cookie-banner-policy-link">Cookie Policy</Link> e nella{" "}
        <Link to="/legale/privacy" data-testid="cookie-banner-privacy-link">Privacy Policy</Link>.
      </p>

      {detailed && (
        <div className="cookie-categories" data-testid="cookie-categories">
          {COOKIE_CATEGORIES.map((category) => (
            <label className="cookie-category" key={category.id} data-testid={`cookie-category-${category.id}`}>
              <input
                type="checkbox"
                checked={category.locked ? true : Boolean(choices[category.id])}
                disabled={category.locked}
                onChange={(event) => setChoices((current) => ({ ...current, [category.id]: event.target.checked }))}
                data-testid={`cookie-toggle-${category.id}`}
              />
              <span>
                <b>{category.label}{category.locked ? " · sempre attivi" : ""}</b>
                <small>{category.text}</small>
              </span>
            </label>
          ))}
        </div>
      )}

      <div className="cookie-actions">
        <button type="button" className="primary-button" onClick={() => decide(ALL_ON)} data-testid="cookie-accept-all">Accetta tutti</button>
        <button type="button" className="secondary-button" onClick={() => decide(ONLY_NEEDED)} data-testid="cookie-only-needed">Solo necessari</button>
        {detailed
          ? <button type="button" className="secondary-button" onClick={() => decide(choices)} data-testid="cookie-save-choices">Salva preferenze</button>
          : <button type="button" className="text-button" onClick={() => setDetailed(true)} data-testid="cookie-customize">Personalizza</button>}
      </div>
    </aside>
  );
}
